<template>

    <v-dialog max-width="500" v-model="dialog">
        <v-card>
            <v-card-title>
                <span class="headline">Hero</span>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" md="6" sm="6">
                        <v-text-field label="Code:" v-model.number="model.code" hide-details/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                        <v-text-field label="Key:" v-model.trim="model.key" hide-details/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" md="6" sm="6">
                        <v-text-field label="Name:" v-model.trim="model.name" hide-details/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                        <v-text-field label="Emotions:" v-model.number="model.emotions" @change="onChange" hide-details/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="12" md="12">
                        <r-worker-kind-dropdown label="Worker kind:" :model.sync="model.worker"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" md="12" sm="12">
                        <v-divider thickness="4"></v-divider>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" md="12" sm="12">
                        <v-slide-group

                                active-class="success"
                                show-arrows>

                            <v-slide-item v-for="emotion in emotions" :key="emotion">

                                <v-card
                                        :color="'green'"
                                        class="ma-1"
                                        elevation="0"
                                        height="180"
                                        width="150"
                                        outlined>

                                    <v-progress-circular v-if="getUrl(emotion) == undefined"
                                                        style="margin-top: 60px; margin-left: 55px"
                                                        indeterminate
                                                        color="orange"
                                    ></v-progress-circular>

                                <div v-else width="150" height="180">
                                    <v-label>{{ getLabel(emotion) }}</v-label>
                                    <v-img width="150" height="150"
                                        :src="getUrl(emotion)">
                                    </v-img>
                                </div>
                            </v-card>

                            </v-slide-item>
                        </v-slide-group>
                    </v-col>
                </v-row>

            </v-card-text>
            <v-card-actions>
                <v-btn @click="onChange" color="blue darken-1" text>
                    Update
                </v-btn>
                <v-spacer/>
                <v-btn @click="onCancel" color="blue darken-1" text>
                    Cancel
                </v-btn>
                <v-btn @click="onPressSave" color="blue darken-1" text>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import VueTypes from "vue-types";
import firebase from "firebase";
import { HeroKind } from "@/modules/redactor/models/hero/HeroKind";
import RWorkerKindDropdown from "../../../redactor/views/worker-kind/r-worker-kind-dropdown.vue";

export default {
    name: "utils-heroes-pop-edit",
    props: {
        skipNone: VueTypes.bool.def(false)
    },
    components: {RWorkerKindDropdown},
    data: () => ({
        loading: {},
        dialog: false,
        onComplete:null,
        model: {},
        ref: {},
        imagesUrls: [],
    }),
    computed: {
        emotions(){
            return Array.from(Array(this.model.emotions).keys());
        }
    },
    
    methods: {

        show(model, onComplete) {
            this.model = Object.assign(new HeroKind(), model);
            this.dialog = true;
            this.onComplete = onComplete;
            if(model){
                this.ref = model;
                this.getImage(model);
            }

            
            
        },
        hide() {
            this.dialog = false;
        },

        onChange(newValue) {
            
            this.getImage(this.model);
        },

        getLabel(emo) {
            return "emotion:" + emo.toString();
        },

        getUrl(emo){
            return this.imagesUrls[emo]
        },
        getImage(hero){
            console.log(this.model);
            for (let emo = 0; emo < hero.emotions; emo++) {
                firebase.storage()
                .ref('assets/ch/'+this.model.key + '_' + emo + '.png')
                .getDownloadURL().then((url) => {
                    this.imagesUrls[emo] = url;
                    this.$forceUpdate();
                }).catch(() => {
                    this.imagesUrls[emo] = require("@/modules/muiutils/resources/no-image-icon.png");
                    this.$forceUpdate();
                });
            }
        },
        onCancel() {
            this.hide();
        },
        onClose() {
            this.hide();
        },
        onPressSave() {
            if (this.model == null || this.model == undefined){
                return;
            }

            if(!this.model.key || this.model.key === ""){

                this.$notify({title: 'Error', text: "invalid Key", type: "error"});
                return;
            }

            if(!this.model.code || this.model.code === 0){

                this.$notify({title: 'Error', text: "invalid Code", type: "error"});
                return;
            }

            if(!this.model.emotions || this.model.emotions === 0){
                this.$notify({title: 'Error', text: "invalid Emotions", type: "error"});
                return;
            }

            this.ref = Object.assign(this.ref, this.model);

            this.dialog = false;
            this.onComplete(this.ref);
        }
    },
}
</script>

<style scoped>

</style>